exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".drop-field {\n  border: 1px solid #d3d3d3;\n  border-radius: 5px;\n  height: 450px;\n  background-color: lightblue;\n  margin: auto;\n}\n.supported-element-panel {\n  margin: 10% auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./App/Components/DiagramViewer/modules/DropArea.less
// module id = 302
// module chunks = 0